import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  type CreateVoucherAutoAssignmentRulePayload,
  type CreateVoucherAutoAssignmentRuleResponse,
  createVoucherAutoAssignmentRule,
} from '~/services/PromoService';

import { voucherAutoAssignmentRuleQueryKeys } from './voucherAutoAssignmentRuleQueryKeys';

export function useCreateVoucherAutoAssignmentRule() {
  const queryClient = useQueryClient();
  return useMutation<CreateVoucherAutoAssignmentRuleResponse, Error, CreateVoucherAutoAssignmentRulePayload>({
    mutationFn: (payload) => createVoucherAutoAssignmentRule(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: voucherAutoAssignmentRuleQueryKeys.all });
    },
  });
}
